/**
 * Config Funnel per lingua (Funnel GLOBAL).
 *
 * ★ 2026-08-27 (Phase 57.D) — Punto centrale di configurazione per
 * Funnel IT/EN/ES. Include URL VSL, Calendly, Meta Pixel ID e ogni
 * altra risorsa specifica per lingua.
 *
 * Al momento EN e ES usano gli stessi asset di IT come placeholder;
 * saranno aggiornati quando l'utente fornerà i link definitivi.
 *
 * ## Come usare
 *   import { getFunnelConfig } from '@/config/funnelByLang';
 *   const { vslUrl, calendlyUrl } = getFunnelConfig(i18n.language);
 */

export const SUPPORTED_LANGS = ['it', 'en', 'es'];
export const DEFAULT_LANG = 'it';

// ── Placeholders (IT reali, EN/ES = copia IT finché utente non manda i link) ─
const VSL_IT = 'https://player.vimeo.com/video/1114787849?badge=0&autopause=0&player_id=0&app_id=58479';
const CALENDLY_IT = 'https://calendly.com/greenparadise-info/30min';

export const FUNNEL_CONFIG = {
  it: {
    lang: 'it',
    label: 'Italiano',
    flag: '🇮🇹',
    vslUrl: VSL_IT,
    calendlyUrl: CALENDLY_IT,
    // Se in futuro vuoi separare Pixel/Ads per lingua, popola qui.
    metaPixelId: null,
    gaMeasurementId: null,
  },
  en: {
    lang: 'en',
    label: 'English',
    flag: '🇬🇧',
    // ⚠️ placeholder: sostituire con URL VSL EN definitivo
    vslUrl: VSL_IT,
    calendlyUrl: CALENDLY_IT,
    metaPixelId: null,
    gaMeasurementId: null,
  },
  es: {
    lang: 'es',
    label: 'Español',
    flag: '🇪🇸',
    // ⚠️ placeholder: sostituire con URL VSL ES definitivo
    vslUrl: VSL_IT,
    calendlyUrl: CALENDLY_IT,
    metaPixelId: null,
    gaMeasurementId: null,
  },
};

/**
 * Ritorna la config del funnel per la lingua richiesta. Fallback su DEFAULT_LANG.
 */
export function getFunnelConfig(lang) {
  const l = (lang || '').split('-')[0].toLowerCase();
  return FUNNEL_CONFIG[l] || FUNNEL_CONFIG[DEFAULT_LANG];
}

/**
 * Ritorna true se il codice lingua è supportato dal funnel multi-lingua.
 */
export function isSupportedLang(lang) {
  const l = (lang || '').split('-')[0].toLowerCase();
  return SUPPORTED_LANGS.includes(l);
}

/**
 * Utility per generare il path public prefissato con la lingua.
 *   pathForLang('it', '/resort/lombok') => '/it/resort/lombok'
 *   pathForLang('en', '/') => '/en'
 */
export function pathForLang(lang, path) {
  const l = isSupportedLang(lang) ? lang : DEFAULT_LANG;
  if (!path || path === '/') return `/${l}`;
  const clean = path.startsWith('/') ? path : `/${path}`;
  return `/${l}${clean}`;
}
